import { createSlice } from '@reduxjs/toolkit';
import { revertAll } from './userReducer';

const initialState = null;

const homeLastEvaluatedKeyReducer = createSlice({
	name: 'homeLastEvaluatedKey',
	initialState: null,
	reducers: {
		setHomeLastEvaluatedKeyData(state, action) {
			return action.payload;
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(revertAll, () => initialState);
	},
});

export const { setHomeLastEvaluatedKeyData } = homeLastEvaluatedKeyReducer.actions;
export default homeLastEvaluatedKeyReducer;